import { IDetailFetcher } from '../fetchers/IDetailFetcher';
import { IListFetcher } from '../fetchers/IListFetcher';
import { ServerDetailFetcher } from '../fetchers/ServerDetailFetcher';
import { ServerResourceFetcher } from '../fetchers/ServerResourceFetcher';
import { Module } from '../Module';
import { IPagedItemsParams } from '../ServerApi/types/IPage';
import { IRequest } from '../../httpClient/serverApi/types/IRequest';

/**
 * @deprecated Use `WebClientDetailFetcher` or `WebClientListResourceFetcher` instead
 */
export class FetcherFactory {

  public static $inject = [
    '$q'
  ];

  constructor(
    private $q: ng.IQService
  ){}

  public getServerDetailFetcher<TRequestResult, TResource>(
    requestMethod: string,
    resultMapper: (result: TRequestResult) => TResource
  ): IDetailFetcher<TResource> {
    return new ServerDetailFetcher(this.$q, requestMethod, resultMapper);
  }

  public getServerResourceFetcher<TRequestResult, TResource>(
    requestType: new (params: IPagedItemsParams) => IRequest<IPagedItemsParams, TRequestResult>,
    resultMapper: (result: TRequestResult) => TResource[]
  ): IListFetcher<TResource> {
    return new ServerResourceFetcher(requestType, resultMapper);
  }

}

Module.instance().service('FetcherFactory', FetcherFactory);
